import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

import Ring from './ring';
import { getWrapperClasses, getWrapperStyles } from './styles';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  const innerBlocksProps = useInnerBlocksProps.save({
    className: 'brandy-circular-badge__centre',
  });

  return (
    <div {...blockProps}>
      <Ring attributes={attributes} />
      <div {...innerBlocksProps} />
    </div>
  );
}
